import $ from 'jquery';
import { throttle } from 'underscore';
/**
 * Enables the "back to top" functionality.
 */
const enableBackToTopFunctionality = () => {
    const $backToTop = $('#back-to-top');
    $(window).on('scroll', throttle(_showBackToTop, 250));
    _showBackToTop();
    // Scrolls to the top of the page
    $backToTop.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 800);
    });
    /**
     * Toggles the "back to top" element.
     */
    function _showBackToTop() {
        const show = (($(window).scrollTop() || 0) > 800);
        if (show) {
            $backToTop.css('visibility', 'visible');
            $backToTop.css('opacity', 1);
        }
        else {
            $backToTop.css('visibility', 'hidden');
            $backToTop.css('opacity', 0);
        }
    }
};
export default enableBackToTopFunctionality;
